export default [
  {
    path: '/Property/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'Property',
        component: () => import('@/views/Property/Zone.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      }
    ]
  }
]
